import { get } from 'lodash';

import { FileErrorCode, ServerFileErrorMessage } from '@/components/elements/DropScan/dropScan.types';

export const getUploadFileErrorCode = (error: unknown): FileErrorCode | undefined => {
  const errorMessage = get(error, 'response.data.elevate_error_message', '') as string;

  if (
    errorMessage?.includes(ServerFileErrorMessage.PasswordProtectedDocument) ||
    errorMessage?.includes(ServerFileErrorMessage.PasswordProtectedFile)
  ) {
    return FileErrorCode.PasswordProtectedDocument;
  }

  if (errorMessage?.includes(ServerFileErrorMessage.DocumentNameIsTooLong)) {
    return FileErrorCode.DocumentNameIsTooLong;
  }

  return undefined;
};

export default getUploadFileErrorCode;
